import React, { useRef, useMemo } from 'react';
import styled from 'styled-components/macro';

import Container from '../Container';
import { getVh } from '../utils';
import useParallax from '../useParallax';
import useTriggerAnimation from '../useTriggerAnimation';

const Uno = styled.img`
  aspect-ratio: 338/411;
  height: auto;

  width: 100rem;
`;

const Dos = styled.img`
  aspect-ratio: 178/119;
  height: auto;
  width: 120rem;

  transform: rotateY(180deg);
`;

const Tonica = () => {

  const ref = {
    figure: {
      uno: useRef<HTMLElement>(null),
      dos: useRef<HTMLElement>(null)
    },
    img: {
      uno: useRef<HTMLImageElement>(null),
      dos: useRef<HTMLImageElement>(null)
    }
  }

  const top = {
    uno: useMemo(() => getVh("history", 0.8), []),
    dos: useMemo(() => getVh("buffer", 0.45), [])
  }

  useTriggerAnimation(ref.figure.uno, top.uno);
  useTriggerAnimation(ref.figure.dos, top.dos);

  useParallax(ref.img.uno, top.uno, 100);
  useParallax(ref.img.dos, top.dos, 100);

  return (
    <>
      <Container
        ref={ref.figure.uno}
        top={top.uno}
        style={{ left: "30vw" }}
      >
        <Uno
          ref={ref.img.uno}
          src="/static/images/fill/tonica/1.png" />
      </Container>

      <Container
        ref={ref.figure.dos}
        top={top.dos}
        style={{ left: "30vw" }}
      >
        <Dos
          ref={ref.img.dos}
          src="/static/images/fill/tonica/2.png"
        />
      </Container>
    </>
  );
}

export default Tonica;